// Constants for DealerDashboard
import defaultVehicleImage from '../../images/default-vehicle.svg';

export const DEFAULT_VEHICLE_IMAGE = defaultVehicleImage;

export const STAGE_COLORS = {
  'Prospect Waiting': '#722ed1',
  'OTD$ Provided': '#1890ff',
  'Lead Waiting': '#fa8c16',
  'TD Scheduled': '#13c2c2',
  'FP Provided': '#52c41a',
  'default': '#d9d9d9'
};

export const STAGE_DESCRIPTIONS = {
  'Prospect Waiting': 'Waiting for OTD quote',
  'OTD$ Provided': 'Price provided',
  'Lead Waiting': 'Test drive requested',
  'TD Scheduled': 'Test drive scheduled',
  'FP Provided': 'FastPass shared'
};

export const STAGE_ICONS = {
  'Prospect Waiting': 'ExclamationCircleOutlined',
  'OTD$ Provided': 'DollarOutlined',
  'Lead Waiting': 'PhoneOutlined',
  'TD Scheduled': 'ScheduleOutlined',
  'FP Provided': 'ShareAltOutlined'
};

export const PRICE_FILTER_OPTIONS = [
  { value: 'under-20k', label: 'Under $20K' },
  { value: '20k-30k', label: '$20K - $30K' },
  { value: '30k-40k', label: '$30K - $40K' },
  { value: '40k-50k', label: '$40K - $50K' },
  { value: 'over-50k', label: 'Over $50K' }
];

export const DATE_FILTER_OPTIONS = [
  { value: 'today', label: 'Today' },
  { value: 'this-week', label: 'This Week' },
  { value: 'this-month', label: 'This Month' },
  { value: 'last-month', label: 'Last Month' }
];

export const STAGE_FILTER_OPTIONS = [
  { value: 'Prospect Waiting', label: 'Prospect Waiting' },
  { value: 'OTD$ Provided', label: 'OTD$ Provided' },
  { value: 'Lead Waiting', label: 'Lead Waiting' },
  { value: 'TD Scheduled', label: 'TD Scheduled' },
  { value: 'FP Provided', label: 'FP Provided' }
];

export const SWIPE_GESTURE_CONFIG = {
  minSwipeDistance: 50
};
